<div class="inner-mat-dialog title-section flex justify-between content-stretch items-stretch flex-col">
    <div mat-dialog-title id="drug-details-header">
      <div class="flex justify-start content-center items-center flex-row">
  
          <div class="flex flex-row justify-start content-stretch items-stretch h-full basis-1/2">
           <h5>DRUG CLASSIFICATION REQUEST</h5>
          </div>
          <div class="flex flex-row justify-end content-stretch items-stretch h-full basis-1/2">
              <mat-icon (click)="this.dialogRef.close()" class="cross-wizard">
                  <img src="/assets/img/icons/ico.16.clear.svg" alt="">
              </mat-icon>
          </div>
      </div>
  </div>
  <div class="mat-elevation-z8" style="overflow: scroll;">
    <table  mat-table [dataSource]="dataSource">
        
        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef width ="30%"> Name </th>
            <td mat-cell *matCellDef="let element" width ="30%"> {{element?.drugName}} </td>
        </ng-container>

        <!-- strength Column -->
        <ng-container matColumnDef="strength">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Strength </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.strength}} </td>
        </ng-container>
  
        <!-- NDC Column -->
        <ng-container matColumnDef="drugNumber">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Drug Number </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.ndc}} </td>
        </ng-container>
  
    
      <!-- priority Column -->
      <ng-container matColumnDef="priority">
          <th mat-header-cell *matHeaderCellDef width ="10%"> Priority </th>
          <td mat-cell *matCellDef="let element" width ="10%"> {{element?.priority}} </td>
      </ng-container>
  
        <!-- Age Column -->
        <ng-container matColumnDef="dcrAge">
            <th mat-header-cell *matHeaderCellDef width ="10%"> DCR Age </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.age}} </td>
        </ng-container>
  
        <!-- Status Column -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Status </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.sfStatus}} </td>
        </ng-container>
  
  
        <!-- caseOwner Column -->
        <ng-container matColumnDef="caseOwner">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Case Owner</th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.owner}} </td>
        </ng-container>

         <!-- caseSource Column -->
         <ng-container matColumnDef="caseSource">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Case Source</th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.source}} </td>
        </ng-container>
  
        <!-- manufacturer Column -->
        <ng-container matColumnDef="manufacturer">
            <th mat-header-cell *matHeaderCellDef width ="10%">Manufacturer </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.manufacturer}} </td>
        </ng-container>

        <!-- caseNumber Column -->
        <ng-container matColumnDef="caseNumber">
            <th mat-header-cell [hidden]="!isCaseNoShow" *matHeaderCellDef> Case Number </th>
            <td mat-cell [hidden]="!isCaseNoShow" *matCellDef="let element"> {{element?.caseNumber}} </td>
          </ng-container>
    
  
        <ng-container matColumnDef="action" >
          <th mat-header-cell *matHeaderCellDef  width ="5%">  </th>
          <td mat-cell *matCellDef="let element" width ="5%">
             <mat-icon (click)="openImportWizardDcrDetails(element?.caseNumber)"  style="margin-bottom: 2px;">
            <img src="/assets/img/icons/ico.12.arwrgt.svg" alt="">
        </mat-icon>
      </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row (click)="selectedRow = row" [ngClass]="{ 'highlight': row === selectedRow }" *matRowDef="let row; columns: displayedColumns;"></tr>
  
  
    </table>
     <table>
        <tr *ngIf="dataSource?.data.length==0">
            <td style="text-align: center;" [attr.colspan]="displayedColumns.length">
                No Records Found!
            </td>
        </tr>
    </table>
  
  </div>
  <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
  
  </mat-paginator>
  
  
  <mat-dialog-actions class="flex flex-row justify-end content-end items-end w-full xs:flex xs:flex-col">
  <button mat-button class="btn-blue-default btn-md" (click)="dialogRef.close()" id="Cancel" aria-label="Cancel" type="button">Cancel</button>
  </mat-dialog-actions>
  
  </div>
  
  
  